import permissionsConstants from 'constants/permissions'

const ALL_PRIVACY_URL =
  'https://comunidade.dponet.com.br/join?invitation_token=de9a105b8ce87fbce9da52f9f60addd5144c0189-3c578fcc-615f-41b1-9431-0ad048a04706'

const GRAPH_IDS = {
  general: {
    welcome: 'welcome-card',
    incidentCard: 'incident-card',
  },
  process: {
    processCards: 'process-cards',
    riskTable: 'process-risks-table',
    riskByDepartment: 'process-risk-by-department',
    departmentByRisk: 'process-department-by-risk',
    statuses: 'status-by-process',
  },
  nonComplianceReports: {
    statuses: 'rmc-status-table',
    finalizedByDepartment: 'rmc-finalized-by-department',
    statusByDepartment: 'rmc-status-by-department',
    overdueByDeparmtnet: 'rmc-overdue-by-department',
    rmcByQuestionnaire: 'rmc-by-questionnaire',
  },
  suppliers: {
    cardStats: 'supplier-card-stats',
    mySupplierCompliance: 'supplier-my-compliancers',
    questionnaireProgress: 'supplier-questionnaire-progress',
    highCompliancers: 'supplier-my-higher-compliancers',
    lowCompliancers: 'supplier-my-lower-compliancers',
    preAvaliatedHighCompliancers: 'supplier-pre-avaliated-high-compliancers',
    preAvaliatedLowCompliancers: 'supplier-pre-avaliated-low-compliancers',
  },
  gap: {
    complianceCard: 'gap-compliance-card',
    questionCard: 'gap-question-card',
    progress: 'gap-progress-by-questionnaire',
    pendingRmc: 'gap-pending-rmcs',
    rmcStatus: 'gap-rmc-status',
    compliance: 'gap-compliance',
    pieChart: 'gap-question-pie-chart',
  },
  pdf: {
    departmentsRmcFinalizeds: 'rmc-finalized-pie-chart',
    departmentsRmcsOverdued: 'rmc-overdued-pie-chart',
    statusRmcsByDepartment: 'rmc-status-bar-chart',
  },
  securityMeasures: {
    statuses: 'security-measures-statuses',
    statusesByCategories: 'security-measures-by-categories',
  },
  fragilities: {
    bySeverities: 'fragilities-by-severities',
    withSecurityMeasures: 'fragilities-with-security-measure',
    departmentsWithHighestFragilities:
      'fragilities-departments-with-highest-fragilities',
    departmentsWithLowestFragilities:
      'fragilities-departments-with-lowest-fragilities',
    departmentsWithHighestSeverities:
      'fragilities-departments-with-highest-severities',
    departmentsWithLowestSeverities:
      'fragilities-departments-with-lowest-severities',
  },
  training: {
    trainedUsersByDepartment: 'trained-users-by-department',
    usersByConclusion: 'users-by-conclusion',
  },
  consent: {
    consentsByForm: 'consents-by-form',
  },
  cookies: {
    cookiesByConsentType: 'cookies-by-consent-type',
  },
  privacyPolicy: {
    acceptedByPrivacyPolicy: 'accepted-by-privacy-policy',
    publicPrivacyPoliciesByType: 'public-privacy-policies-by-type',
  },
  ticket: {
    ticketByAnswerOption: 'ticket-by-answer-option',
    ticketByStatus: 'ticket-by-status',
  },
  complaint: {
    complaintByStatus: 'complaint-by-status',
  },
}

const DASHBOARD_MAIN_TAB = 'dashboard-main-tab'
const DASHBOARD_PROCESS_TAB = 'dashboard-process-tab'
const DASHBOARD_DIAGNOSTIC_TAB = 'dashboard-diagnostic-tab'
const DASHBOARD_SUPPLIER_TAB = 'dashboard-supplier-tab'
const DASHBOARD_TRAINING_TAB = 'dashboard-training-tab'
const DASHBOARD_CONSENT_TAB = 'dashboard-consent-tab'
const DASHBOARD_COOKIES_TAB = 'dashboard-cookies-tab'
const DASHBOARD_DOCUMENTS_TAB = 'dashboard-documents-tab'
const DASHBOARD_TICKET_TAB = 'dashboard-ticket-tab'
const DASHBOARD_COMPLAINT_TAB = 'dashboard-complaint-tab'
const DASHBOARD_ACTIVITIES_TAB = 'dashboard-activities-tab'

const HOME_DRIVER_STEP_1 = 'home-step-1'
const HOME_DRIVER_STEP_2 = 'home-step-2'
const HOME_DRIVER_STEP_3 = 'home-step-3'
const HOME_DRIVER_STEP_4 = 'home-step-4'
const HOME_DRIVER_STEP_5 = 'home-step-5'
const HOME_DRIVER_STEP_6 = 'home-step-6'

const DRIVER_STEPS_OBJECT_WITH_PERMISSIONS = {
  ['#' + HOME_DRIVER_STEP_5]:
    permissionsConstants.HOME.SHOW_COMMUNICATION_TRAIL,
}

const DRIVER_STEPS_OBJECT = [
  {
    element: '#' + HOME_DRIVER_STEP_1,
    popover: {
      title: 'Bem-vindo a plataforma',
      description:
        'Vamos guiá-lo pelo sistema para que você consiga dar os primeiro passos.',
    },
  },
  {
    element: '#' + HOME_DRIVER_STEP_2,
    popover: {
      description:
        'Explore seu perfil! Ajuste suas configurações; personalize as informações do perfil, incluindo dados pessoais e dados da empresa.',
    },
  },
  {
    element: '#' + HOME_DRIVER_STEP_3,
    popover: {
      title: 'Mantenha-se atualizado',
      description: 'Visite as novas funcionalidades e melhorias na plataforma.',
    },
  },
  {
    element: '#' + HOME_DRIVER_STEP_4,
    popover: {
      description:
        'Realize o acesso inicial para descobrir benefícios exclusivos, incluindo recursos educacionais sobre a LGPD. Aprofunde-se na legislação, aprenda melhores práticas através de vídeos. Destaque-se ao obter o certificado e selo, demonstrando comprometimento com a proteção de dados.',
    },
  },
  {
    element: '#' + HOME_DRIVER_STEP_5,
    popover: {
      description:
        'Personalize seu canal de comunicação com a logomarca e identidade visual da sua organização, nomeie seu Encarregado de Proteção de Dados(DPO) (se aplicável), configure o aviso de privacidade e gere o selo do site.Por fim, realize a primeira etapa de configuração do banner de cookies. É possível prosseguir com a jornada do banner agora (sendo redirecionado para a tela correspondente) ou deixar para finalizar posteriormente.',
    },
  },
  {
    element: '#' + HOME_DRIVER_STEP_6,
    popover: {
      title: 'Treinamentos de Conscientização',
      description:
        'Aqui estão disponíveis os cursos básicos sobre a Lei Geral de Proteção de Dados. Você poderá aprender os conceitos fundamentais da LGPD, política de mesa e tela limpa, uso de inteligência artificial em conformidade com a LGPD e princípios de Privacy by Design. Ao concluir os treinamentos, é possível obter o certificado correspondente.',
    },
  },
]

const DASHBOARD_DRIVER_STEP_1 = 'dashboard-driver-step-1'
const DASHBOARD_DRIVER_STEP_2 = 'dashboard-driver-step-2'

const DASHBOARD_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + DASHBOARD_DRIVER_STEP_1,
    popover: {
      description:
        'O Dashboard é uma ferramenta de visualização de dados que apresenta informações de forma consolidada e acessível, facilitando o monitoramento do desempenho, a identificação de tendências, a análise de métricas e a tomada de decisões embasadas nos dados apresentados.',
    },
  },
  {
    element: '#' + DASHBOARD_DRIVER_STEP_2,
    popover: {
      description:
        'Utilize os filtros para visualizar informações específicas da plataforma, incluindo:   <strong>processos, diagnósticos, fornecedores, treinamentos, consentimentos, cookies, documentos, titulares e canal de denúncias</strong>.',
    },
  },
]

export default {
  ALL_PRIVACY_URL,
  DASHBOARD_ACTIVITIES_TAB,
  DASHBOARD_COMPLAINT_TAB,
  DASHBOARD_CONSENT_TAB,
  DASHBOARD_COOKIES_TAB,
  DASHBOARD_DIAGNOSTIC_TAB,
  DASHBOARD_DOCUMENTS_TAB,
  DASHBOARD_DRIVER_STEP_1,
  DASHBOARD_DRIVER_STEP_2,
  DASHBOARD_DRIVER_STEPS_OBJECT,
  DASHBOARD_MAIN_TAB,
  DASHBOARD_PROCESS_TAB,
  DASHBOARD_SUPPLIER_TAB,
  DASHBOARD_TICKET_TAB,
  DASHBOARD_TRAINING_TAB,
  DRIVER_STEPS_OBJECT_WITH_PERMISSIONS,
  DRIVER_STEPS_OBJECT,
  GRAPH_IDS,
  HOME_DRIVER_STEP_1,
  HOME_DRIVER_STEP_2,
  HOME_DRIVER_STEP_3,
  HOME_DRIVER_STEP_4,
  HOME_DRIVER_STEP_5,
  HOME_DRIVER_STEP_6,
}
